import { useMutation } from '@apollo/react-hooks'
import { useUser } from '@paintscout/ui'
import LogRocket from 'logrocket'
import { gql } from 'apollo-boost'
import { useEffect, useRef } from 'react'

export default function HubspotChat() {
  const { user } = useUser()
  const [associateSupportTicket] = useMutation(gql`
    mutation associateSupportTicket($conversationId: String!, $logRocketUrl: String) {
      associateSupportTicket(conversationId: $conversationId, logRocketUrl: $logRocketUrl)
    }
  `)

  const logRocketUrlRef = useRef<string | null>(null)

  useEffect(() => {
    try {
      LogRocket.getSessionURL((sessionURL) => {
        console.log('LogRocket session URL:', sessionURL)
        logRocketUrlRef.current = sessionURL
      })
    } catch (error) {
      console.error('Error fetching LogRocket session URL:', error)
    }
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      const hsConversations = (window as any).HubSpotConversations
      if (hsConversations) {
        const handler = ({ conversation }) => {
          const conversationId = conversation.conversationId
          console.log('HubSpot conversation started:', { conversationId })
          associateSupportTicket({
            variables: { conversationId: conversationId.toString(), logRocketUrl: logRocketUrlRef.current }
          })
        }

        ;(window as any).hsConversationsSettings = {
          identificationEmail: user.email,
          identificationToken: user.user_metadata.hubspotVisitorToken
        }
        hsConversations.clear({ resetWidget: true })
        hsConversations.on('conversationStarted', handler)
        hsConversations.widget.load()
        clearInterval(interval)

        return () => hsConversations.off('conversationStarted', handler)
      }
    }, 100)

    return () => clearInterval(interval)
  }, [])

  return null
}
